import React, { useEffect, useState } from 'react';
import Table from '../../../../components/table/Table';
import { connect } from 'react-redux';
import { ZusLademittelModel } from '../../../../models/ZusLademittelModel';
import { getLademittel } from '../../../../redux/actions/lademittel';
import { LademittelModel } from '../../../../models/LademittelModel';
import { getEigentuemer } from '../../../../redux/actions/eigentuemer';
import { EigentuemerModel } from '../../../../models/EigentuemerModel';
import { initzusLademittelTableConfig } from './ZuslademittelTableConfig';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../redux/store';
import { setCurrentZusLademittel } from '../../../../redux/actions/auftragserfassung';
import Button, { ButtonType } from '../../../../components/button/Button';

interface ZusLademittelProps {
  auftrag: StateModel_Auftragserfassung;
  resetToggle: boolean;
  currentZusLademittel: ZusLademittelModel[];
  setCurrentZusLademittel: any;
  getLademittel: any;
  lademittel: Array<LademittelModel>;
  getEigentuemer: any;
  eigentuemer?: Array<EigentuemerModel>;
  currentMandantId: string;
  close: () => void;
}

/**
 * Component fuer die ZusZahlungsmittel Tabelle.
 *
 * @returns {JSX.Element}
 */
const Zuslademittel = (props: ZusLademittelProps) => {
  const [tableConfig, setTableConfig] = useState(
    initzusLademittelTableConfig(props.lademittel, props.eigentuemer)
  );
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const [tempZusLademittel, setTempZusLademittel] = useState<
    ZusLademittelModel[]
  >(props.currentZusLademittel);

  const reset = () => {
    props.setCurrentZusLademittel(initData());
    init();
  };

  const init = () => {
    props.getLademittel(props.auftrag.mandant?.id ?? +props.currentMandantId);
    props.getEigentuemer();
  };

  const close = () => {
    props.close();
  };

  const abbrechen = () => {
    props.setCurrentZusLademittel(tempZusLademittel);
    close();
  };

  useEffect(() => {
    const lademitteltmp = [...props.lademittel];
    const tmpColumnConfig = [...tableConfig];
    const lademittelIndex = tmpColumnConfig.findIndex(
      configEntry => configEntry.attributName === 'lademittel'
    );
    tmpColumnConfig[lademittelIndex] = {
      ...tmpColumnConfig[lademittelIndex],
      selectData: toSelectOptions(lademitteltmp, 'kurzBezeichnung', true),
    };
    setTableConfig(tmpColumnConfig);
  }, [props.lademittel]);

  useEffect(() => {
    if (props.eigentuemer) {
      const eigentuemertmp = [...props.eigentuemer];

      const tmpColumnConfig = [...tableConfig];
      const eigentuemerIndex = tmpColumnConfig.findIndex(
        configEntry => configEntry.attributName === 'eigentuemer'
      );
      tmpColumnConfig[eigentuemerIndex] = {
        ...tmpColumnConfig[eigentuemerIndex],
        selectData: toSelectOptions(eigentuemertmp, 'name', true),
      };
      setTableConfig(tmpColumnConfig);
    }
  }, [props.eigentuemer]);

  useEffect(() => {
    init();
  }, [props.resetToggle]);

  const zusLademittelIsEmpty = (zusLademittel: ZusLademittelModel): boolean => {
    return (
      !zusLademittel.id &&
      !zusLademittel.auftragId &&
      !zusLademittel.lademittel &&
      !zusLademittel.eigentuemer &&
      !zusLademittel.anzFolge &&
      !zusLademittel.anzahl
    );
  };
  const setAnzfolgeAuftragId = () => {
    for (const zusla of props.currentZusLademittel) {
      if (zusLademittelIsEmpty(zusla)) {
        zusla.anzFolge = undefined;
        zusla.auftragId = undefined;
      } else {
        zusla.anzFolge = props.currentZusLademittel.indexOf(zusla) + 1;
        zusla.auftragId = props.auftrag.id;
      }
    }
  };

  return (
    <div className='wrapper-zuslademittel'>
      <div className='wrapper-zuslademittel-table'>
        <Table
          tableConfig={tableConfig}
          edit={true}
          setTableConfig={setTableConfig}
          data={props.currentZusLademittel}
          setData={props.setCurrentZusLademittel}
          defaultEmptyRow={{ ...defaultRow }}
          tabSkipIndices={[0]}
          selectByAllTablecells={false}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          tableCellOnBlur={setAnzfolgeAuftragId}
        />
      </div>
      <div className={'hinweis'}>
        * Hinweis: Markieren einer Zeile durch Klick in die Spalte
        &quot;Nr.&quot;, Löschen einer Zeile mit Taste ENTF
      </div>
      <div className={'zusla_buttonpair'}>
        <Button key={'b1'} onClickHandler={() => abbrechen()}>
          Abbrechen
        </Button>
        <Button
          key={'b2'}
          type={ButtonType.submit}
          onClickHandler={() => close()}
        >
          Bestätigen
        </Button>
      </div>
    </div>
  );
};

const initData = (): Array<ZusLademittelModel> => {
  return [
    {
      id: undefined,
      auftragId: undefined,
      anzFolge: undefined,
      anzahl: undefined,
      lademittel: undefined,
      eigentuemer: undefined,
    },
  ];
};

const defaultRow: ZusLademittelModel = {
  id: undefined,
  auftragId: undefined,
  anzFolge: undefined,
  anzahl: undefined,
  lademittel: undefined,
  eigentuemer: undefined,
};

// zieht die Sachen aus dem redux State, damit sie hier benutzt werden können
const mapStateToProps = (state: StateModel) => ({
  auftrag: state.Auftragserfassung,
  resetToggle: state.Auftragserfassung.resetToggle,
  currentZusLademittel: state.Auftragserfassung.currentZusLademittel,
  lademittel: state.Stammdaten.lademittel,
  eigentuemer: state.Stammdaten.eigentuemer,
  currentMandantId: state.UserSession.currentMandantId,
});

export default connect(mapStateToProps, {
  setCurrentZusLademittel,
  getLademittel,
  getEigentuemer,
})(Zuslademittel);
